import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.module';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { AuthenticateGuard, ErrorHandlerService, PrivilegeGuard } from '@inera/common';
import { DefaultRouteGuard } from './security/default-route-guard.service';
import { AuthInterceptor } from './security/auth-interceptor';
import { ClientToolsErrorHandlerService } from './services/client-tools-error-handler.service';

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: ErrorHandlerService,
      useClass: ClientToolsErrorHandlerService,
    },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([AuthInterceptor])),
    AuthenticateGuard,
    DefaultRouteGuard,
    PrivilegeGuard,
  ],
};
